import { axiosInstance } from '@/Api/axiosV2Config';
import type {
  CoveragePreset,
  CoveragePresetDetail,
  CreateCoveragePresetDto,
  UpdateCoveragePresetDto,
  UpdatePresetPartsDto,
} from '../types/coverage-preset.types';

/**
 * API client pour la gestion des presets de couverture
 * Utilise les endpoints /coverage-presets
 */
export const coveragePresetApi = {
  // ==================== LECTURE ====================

  /**
   * Récupérer les presets pour un type de véhicule
   */
  getPresetsByVehicleType: async (
    vehicleType: number,
    lang = 'fr',
  ): Promise<CoveragePreset[]> => {
    const { data } = await axiosInstance.get<CoveragePreset[]>('/coverage-presets', {
      params: { vehicleType, lang },
    });
    return data;
  },

  /**
   * Récupérer un preset par ID avec détails complets (incluant les pièces)
   */
  getPresetById: async (id: number, lang = 'fr'): Promise<CoveragePresetDetail> => {
    const { data } = await axiosInstance.get<CoveragePresetDetail>(`/coverage-presets/${id}`, {
      params: { lang },
    });
    return data;
  },

  // ==================== CRUD (Internal users only) ====================

  /**
   * Créer un nouveau preset
   */
  createPreset: async (preset: CreateCoveragePresetDto): Promise<CoveragePreset> => {
    const { data } = await axiosInstance.post<CoveragePreset>('/coverage-presets', preset);
    return data;
  },

  /**
   * Mettre à jour un preset (informations générales)
   */
  updatePreset: async (id: number, preset: UpdateCoveragePresetDto): Promise<CoveragePreset> => {
    const { data } = await axiosInstance.patch<CoveragePreset>(
      `/coverage-presets/${id}`,
      preset,
    );
    return data;
  },

  /**
   * Mettre à jour les pièces d'un preset
   */
  updatePresetParts: async (
    id: number,
    partsDto: UpdatePresetPartsDto,
  ): Promise<CoveragePreset> => {
    const { data } = await axiosInstance.patch<CoveragePreset>(
      `/coverage-presets/${id}/parts`,
      partsDto,
    );
    return data;
  },

  /**
   * Supprimer un preset
   */
  deletePreset: async (id: number): Promise<void> => {
    await axiosInstance.delete(`/coverage-presets/${id}`);
  },
};
